import { IOrder } from '../../../../../app/entities/Order'

export const initialOrderData: IOrder = {
  addBtIds: null,
  additionalTireRackOrderNumber: null,
  assignedTo: null,
  cancellationNote: '',
  cancellationReason: null,
  cases: [],
  created: 0,
  createdFrom: null,
  discounts: [],
  ecomId: null,
  estimateFormUrl: null,
  memberId: null,
  note: null,
  notificationsLog: undefined,
  objectId: '',
  orderHistory: [],
  orderServices: [],
  orderVehicles: [],
  originZipCode: null,
  rating: 0,
  routeInstructions: [],
  scheduledMessages: [],
  shouldRequestPaymentAfterScheduling: false,
  source: null,
  standbyQueueMessages: [],
  status: null,
  step: null,
  surveyUrl: null,
  timeOptedIntoStandbyQueue: null,
  tireArrivalStatus: '',
  tireRackOrders: [],
  updated: 0,
  invoices: [],
  workOrderId: 0,
}
